import React, { FunctionComponent } from "react";

const MessagesBubbleSquareWarningIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/messages-chat-smileys/messages-speech-bubbles/messages-bubble-square-warning
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.25 -0.25 24.5 24.5">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 18.75H11.25L5.25 23.25V18.75H2.25C1.85218 18.75 1.47064 18.592 1.18934 18.3107C0.908035 18.0294 0.75 17.6478 0.75 17.25V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H21.75C22.1478 0.75 22.5294 0.908035 22.8107 1.18934C23.092 1.47064 23.25 1.85218 23.25 2.25V17.25C23.25 17.6478 23.092 18.0294 22.8107 18.3107C22.5294 18.592 22.1478 18.75 21.75 18.75Z"
      ></path>
      <path
        stroke="currentColor"
        d="M12.75 15C12.5429 15 12.375 14.8321 12.375 14.625C12.375 14.4179 12.5429 14.25 12.75 14.25"
      ></path>
      <path
        stroke="currentColor"
        d="M12.75 15C12.9571 15 13.125 14.8321 13.125 14.625C13.125 14.4179 12.9571 14.25 12.75 14.25"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.75 11.25V5.25"
      ></path>
    </svg>
  );
};

export default MessagesBubbleSquareWarningIcon;
